// react
import React from 'react';
import styled from 'styled-components';
import { css } from 'styled-components';

/**
 * Title is the title of a page.
 */
export const Title = ({
  className,
  children,
  isNoMargin = false,
  isCenter = false,
  size = 'md',
}: TitleProps) => {
  return (
    <StyledTitle
      className={className}
      $isNoMargin={isNoMargin}
      $isCenter={isCenter}
      $size={size}
    >
      {children}
    </StyledTitle>
  );
};

interface StyledTitleProps {
  $isNoMargin?: boolean;
  $isCenter?: boolean;
  $size?: TitleSize;
}
const StyledTitle = styled.div<StyledTitleProps>`
  font: ${(props) => {
    switch (props.$size) {
      case 'sm':
        return props.theme.typography.heading['3xl'];
      case 'md':
      default:
        return props.theme.typography.heading['5xl'];
    }
  }};
  color: ${(props) => props.theme.color.primary[80]};
  ${(props) =>
    !props.$isNoMargin &&
    css`
      margin-bottom: ${props.theme.spacing[36]};
    `}
  ${(props) => props.$isCenter && 'text-align: center;'}
`;

type TitleSize = 'sm' | 'md';

interface TitleProps {
  className?: string;
  children: React.ReactNode;
  isNoMargin?: boolean;
  isCenter?: boolean;
  size?: TitleSize;
}

Title.displayName = 'Title';

export default Title;
